import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { Country } from '/@/modules/predefined/models/Country';
import { commits, getters } from '/@/modules/core/app/helpers/store';

export class CountryService extends BaseEntityService {
  getRoute() {
    return Route.PREDEFINED_COUNTRIES;
  }

  getModel() {
    return Country;
  }

  /**
   * @returns {Array.<Country>}
   */
  async getItems(params = {}) {
    let items = getters.predefined.getActiveCountries();
    if (items) {
      return items;
    }

    items = await this.getEntities(params);

    commits.predefined.setCountries(items);
    commits.predefined.setActiveCountries(items.filter((country) => country.active));

    return items;
  }

  /**
   * @param {string} name
   * @returns {Country}
   */
  getCountryByName(name) {
    return getters.predefined.getCountries().find((country) => country.name === name);
  }

  /**
   * @param {number} id
   * @returns {Country}
   */
  getActiveCountryById(id) {
    return getters.predefined.getActiveCountries().find((country) => country.id === id);
  }

  /**
   * @param {number} id
   * @returns {Country}
   */
  getCountryById(id) {
    return getters.predefined.getCountries().find((country) => country.id === id);
  }
}

export default new CountryService();
